import { Card, CardContent, CardHeader } from '@/components/ui/card';
import { Skeleton } from '@/components/ui/skeleton';

import { PurchaseOrderMainTotalsSkeleton } from './purchase-order-main-totals-skeleton';

export function PurchaseOrderMainSkeleton() {
  return (
    <div className='grid grid-cols-1 gap-4 lg:grid-cols-2'>
      <div className='flex justify-end lg:col-span-2'>
        <Skeleton className='h-11 w-36' />
      </div>

      <div className='space-y-4'>
        <Card>
          <CardHeader>
            <Skeleton className='h-6 w-52' />
          </CardHeader>
          <CardContent>
            <div className='flex justify-between gap-4'>
              <Skeleton className='h-5 w-44' />
              <Skeleton className='size-6 shrink-0 rounded-sm' />
            </div>
          </CardContent>
          <CardHeader>
            <Skeleton className='h-6 w-48' />
          </CardHeader>
          <CardContent>
            <Skeleton className='h-4 w-full max-w-md' />
          </CardContent>
        </Card>

        <Card>
          <CardHeader>
            <Skeleton className='h-6 w-56' />
          </CardHeader>
          <CardContent className='space-y-3'>
            <Skeleton className='h-14 w-full' />
            <Skeleton className='h-14 w-full' />
            <Skeleton className='h-10 w-full' />
          </CardContent>
        </Card>
      </div>

      <div className='space-y-4'>
        <Card>
          <CardHeader>
            <Skeleton className='h-6 w-44' />
          </CardHeader>
          <CardContent>
            <div className='grid grid-cols-1 gap-4 sm:grid-cols-3'>
              <Skeleton className='h-[4.25rem] w-full rounded-md' />
              <Skeleton className='h-[4.25rem] w-full rounded-md' />
              <Skeleton className='h-[4.25rem] w-full rounded-md' />
            </div>
          </CardContent>
        </Card>

        <PurchaseOrderMainTotalsSkeleton />
      </div>
    </div>
  );
}
